import ScrollHelper from '../utils/scroll-helper'

function navigateToBlock(e) {
  e.preventDefault()

  const blockId = e.currentTarget.getAttribute('href')
  const targetEl = document.querySelector(blockId)

  ScrollHelper.scrollToTarget(blockId)
  targetEl.focus()
}

export default {
  init() {
    const skipLinksEl = document.querySelector('.skip-links')

    if (skipLinksEl) {
      const links = skipLinksEl.querySelectorAll('a')

      links.forEach(link => {
        link.addEventListener('click', navigateToBlock)
      })
    }
  },
}
